import { combineReducers } from 'redux';

import { createResourceModuleReducerMap, mlRel } from 'medialoopster/rest';

import { SiteExportConfigRootState } from './types';

export default combineReducers<SiteExportConfigRootState>(
  createResourceModuleReducerMap('siteexportconfig', mlRel('siteexportconfigs')),
);
